import React, { useState, useEffect, useContext, useMemo } from "react";
import GOLD from "../../assets/img/rates/gold.png";
import NEPSE from "../../assets/img/rates/nepse.png";
import FOREX from "../../assets/img/rates/forex.png";
import Irate from "../../assets/img/rates/irate.jfif";
import "./latestRates.scss";
import { Link } from "react-router-dom";
import { TabTitle } from "../../common/dynamicTitle";
import { useParams } from "react-router-dom";
import Breadcrumbs from "../../common/breadcumb";
import { LangContext } from "../../context/LangContext";
function LatestRate() {
  const { state } = useContext(LangContext);
  const nep = state.np;
  const pageTitle = useMemo(() => {
    return nep ? "नयाँ दरहरू" : "Latest Rates";
  }, [nep]);
  TabTitle(`GMBF | ${pageTitle}`);
  return (
    <>
      <Breadcrumbs PageTitle={pageTitle} />
      <main className="InsidePageContainer">
        <div className="main-box">
          <div className="wrapper">
            <div className="main-box-container">
              <Link to="/rates/interest-rates">
                <div className="latest-rate-body">
                  <div className="latest-rate-img">
                    <img src={Irate} alt="Interest Rates" />
                  </div>
                  <div className="latest-rate-title">
                    {nep ? "ब्याज दरहरू" : "Interest Rates"}
                  </div>
                </div>
              </Link>
              <Link
                to="https://www.nepalstock.com.np/company/detail/263"
                target="_blank"
              >
                <div className="latest-rate-body">
                  <div className="latest-rate-img">
                    <img src={NEPSE} alt="NEPSE Prices" />
                  </div>
                  <div className="latest-rate-title">
                    {nep ? "नेप्से दरहरू" : "NEPSE Rates"}
                  </div>
                </div>
              </Link>
              <Link to="https://www.fenegosida.org/" target="_blank">
                <div className="latest-rate-body">
                  <div className="latest-rate-img">
                    <img src={GOLD} alt="Gold Rates" />
                  </div>
                  <div className="latest-rate-title">
                    {nep ? "सुनको मूल्य" : "Gold Rates"}
                  </div>
                </div>
              </Link>
              <Link to="../forex-rates">
                <div className="latest-rate-body">
                  <div className="latest-rate-img">
                    <img src={FOREX} alt="Fores Rates" />
                  </div>
                  <div className="latest-rate-title">
                    {nep ? "विदेशी मुद्रा दर" : "Forex Rates"}
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default LatestRate;
